import {ActionOrigin} from 'constants/AnalyticsConstants';
import {REGISTRIES_FINDER_ID} from 'constants/NavConstants';
import {AutofillNames} from 'metadata/AutoFillLink';
import {
  AutoFillFeatureResultProps,
  trackAutofillFeatureResult,
  trackSubmitAutoFillFeature,
} from 'molbio/SequenceAnalyticsHelper';

function getAutoFillActionOrigin(finderId: string): ActionOrigin {
  const isRegistry = finderId === REGISTRIES_FINDER_ID;
  return isRegistry
    ? ActionOrigin.REGISTRY_EXPANDED_SEARCH_TOOLBAR
    : ActionOrigin.SEARCH_EXPANDED_SEARCH_TOOLBAR;
}

export function trackAutoFillAnalytics(
  itemIds: Array<string>,
  autofillName: AutofillNames,
  finderId: string,
  autofillRunUID?: string
): void {
  trackSubmitAutoFillFeature(itemIds, getAutoFillActionOrigin(finderId), autofillName, autofillRunUID);
}

export function generateAutoFillResultAnalytics(
  autofillName: AutofillNames,
  autofillRunUID: string,
  finderId: string
): (props: AutoFillFeatureResultProps) => void {
  return (props: AutoFillFeatureResultProps) => {
    trackAutofillFeatureResult({
      actionOrigin: getAutoFillActionOrigin(finderId),
      autofillRunUID,
      autofillName,
      sequenceId: props.sequenceId,
      autofillCount: props.autofillCount,
      autofillErrors: props.autofillErrors,
    });
  };
}
